module.exports = __webpack_public_path__ + "img/icb-leo-Inte-m.cbbf0b01.png";